import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import rootReducer from './reducers/rootReducer';

import { Message, TrackAndTrace } from '../api';
import { ConfigModel } from '../models/ConfigModel';

const initialState = {};

const middleware = [thunk];
export type storeType = typeof store;
export const store = createStore(
  rootReducer,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

// set up a store subscription listener
// to store the users token in localStorage

// initialize current state from redux store for subscription comparison
// preventing undefined error
let currentState = store.getState();

store.subscribe(() => {
  // keep track of the previous and current state to compare changes
  const previousState = currentState;
  currentState = store.getState();
});

export default store;

export interface StateModel {
  Config: ConfigModel;
  TT: TrackAndTrace;
  Modal: StateModel_Modal;
  Loading: StateModel_Loading;
  message: Message;
}

export interface StateModel_Loading {
  loading: boolean;
}

export interface StateModel_Modal {
  config: {
    show: false;
    children: undefined;
    height: undefined;
    width: undefined;
    title: undefined;
    description: undefined;
  };
}
